import TextToggle from './component'
export default TextToggle
